import { type Path, httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';
type ServiceSuggestionRequest = {
  service_id: string;
  path: Path[];
  package_size: string;
  package_weight: string | number;
};

type ServiceSuggestionResponse = {
  delivery_type: string;
  is_valid_service: boolean;
};

export const postServiceSuggestionFn = async (
  body: ServiceSuggestionRequest
) => {
  const response = await httpClient.post<ServiceSuggestionResponse>(
    apiRoutes.suggestion,
    body
  );
  return response.data;
};
